import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../Store/store.ts';
import { IsProductPage } from '../../FitAssistantShared/IsProductPage.js';
import { ResetFitStatusForAllProducts } from '../../FitAssistantShared/Functions.js';
import { trackReset } from '../Analytics/Adobe.ts';
import { CookieHelper } from '../Helpers/CookieHelper.ts';
import FitAssistantVariation from '../Enums/FitAssistantVariation.ts';
import { InstructionTextHelper } from '../Helpers/InstructionTextHelper.ts';
import { resetRoofRackMediaFilter } from '../Util/ProductPageUtils.tsx';

export const resetFitAssistant = createAsyncThunk<void, boolean>(
  'fitAssistant/reset',
  async (skipEvent: boolean, { getState }) => {
    const state = getState() as RootState;

    const fitAssistant = state.FitAssistant;
    const initialData = fitAssistant.initialData;

    CookieHelper.RemoveCookies();

    const productType = window._THULEDATA?.ProductDetail?.ProductType;
    const hideAtcButtons =
      initialData.FitAssistantVariation === FitAssistantVariation.CarRoofRacks ||
      (initialData.FitAssistantVariation === FitAssistantVariation.TruckRackSystem &&
        productType?.toLowerCase() === 'dummy product');

    ResetFitStatusForAllProducts(hideAtcButtons);

    if (IsProductPage) {
      let url = new URL(window.location.href);
      url.search = '';
      history.replaceState(null, '', url.toString());

      resetRoofRackMediaFilter();

      if (InstructionTextHelper.HasInstructionText(initialData.FitAssistantVariation)) {
        InstructionTextHelper.ShowInstructionText();
      }
    }

    if (!skipEvent) {
      trackReset(
        initialData.FitAssistantVariation,
        fitAssistant.step,
        initialData.IsYearFirst,
        fitAssistant.carInformation
      );
    }
  }
);
